import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import httpService from './httpService';

export const getDatasheet: any = createAsyncThunk<any>(
	'getDatasheet',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/tenant-portal/dataSheet',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error);
		}
	}
);
export const getDatasheetPriceAndInventory: any = createAsyncThunk<any>(
	'getDatasheetPriceAndInventory',
	async ({ data, type }: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				`/productService/dataSheet/${type}`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error);
		}
	}
);
export const getColumnFields: any = createAsyncThunk<any>(
	'getColumnFields',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/tenant-portal/columnField',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getFileUploadSignature: any = createAsyncThunk<any>(
	'getFileUploadSignature',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(
				`/tenant-portal/dataSheet/import/getUploadSignature`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const uploadFileRecordStatus: any = createAsyncThunk<any>(
	'uploadFileRecordStatus',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(
				`/tenant-portal/dataSheet/import/updateUploadFile`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error);
		}
	}
);
export const getDatasheetList: any = createAsyncThunk<any>(
	'getDatasheetList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/tenant-portal/dataSheet', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getDatasheetFile: any = createAsyncThunk<any>(
	'getDatasheetFile',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_DATA_SHEET}dataSheet/${data.tenantId}/${data.dataType}/${data.operationType}/import/${data.fileName}`
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const validationApproveAllForDatasheet: any = createAsyncThunk<any>(
	'validationApproveAllForDatasheet',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(
				`/tenant-portal/dataSheet/import/validation`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error);
		}
	}
);
export const deleteDatasheets: any = createAsyncThunk<any>(
	'deleteDatasheets',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/tenant-portal/dataSheet',
				{ data: data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
